// extracted by mini-css-extract-plugin
export default {"info-modal":"BaseInfoModal-qcCtI__info-modal","content":"BaseInfoModal-5dt-m__content","button":"BaseInfoModal-ZBKaW__button","headline":"BaseInfoModal-sQc61__headline"};